import { connect, MapStateToProps } from "react-redux";

import { getAttributeInfoByName, getRecordById } from "@multiweb/reactCore/datasource";
import { IAppState, RecordType } from "@multiweb/types/react";
import { FrameAttributeSharedProps } from "../../../../types";
import { ParticipantTypeAttributeComponent } from "./ParticipantTypeAttributeComponent";

export type ParticipantTypeAttributeProps = FrameAttributeSharedProps & {
    record?: RecordType;
};

type StateProps = Pick<ParticipantTypeAttributeProps, "record">;

const mapStateToProps: MapStateToProps<StateProps, ParticipantTypeAttributeProps, IAppState> = (
    state,
    { dataSourceKey, attributeName, recordId },
) => ({
    record: getRecordById(state, { dataSourceKey, recordId }),
    dataSourceAttributeInfo: getAttributeInfoByName(state, { dataSourceKey, attributeName }),
});

export const ParticipantTypeAttribute = connect(mapStateToProps)(ParticipantTypeAttributeComponent);
